import React, { useState } from 'react';
import Modal from '../../../../../components/Modal';
import PropTypes from 'prop-types';
import duplicate from '../../../../../assets/images/duplicate.png';
import DropDown from '../../../../../components/DropDown';
import { useAssignmentContext } from '../../../context';
import appConfig from '../../../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../../../features/authentication/authSlice';
import CustomToast from '../../../../../components/Toast';

const baseUrl = appConfig.apiBaseUrl;
const DuplicateMenuModal = ({ modalData, setModalData, fromMoreActions }) => {
  const token = useSelector(selectCurrentToken);
  const [assignViaId, setAssignViaId] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const selectedAssignment = useAssignmentContext();
  const duplicateAssignmentAsync = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options =
          !fromMoreActions
            ? selectedAssignment.assignedData.map((item) => item.assignmentId)
            : [selectedAssignment.assignmentId];
        const queryParam = 'assignedViaId=' + assignViaId;
        let url = baseUrl + '/Assignment/DuplicateAssignments?' + queryParam;
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
        const response = await fetch(url, {
          headers,
          method: 'POST',
          body: JSON.stringify(options)
        });
        const errorMsg = await response.text();
        const result = response.status;
        if (result === 200) {
          CustomToast(
            `Assignment Duplicated : ${!fromMoreActions
              ? selectedAssignment.assignedData.length
              : '1'
            }`,
            'success'
          );
          setModalData(false);
          selectedAssignment.setAssignedDataStatus(new Date().getSeconds());
          selectedAssignment.setAssignedData([]);
          setIsLoading(false);
          selectedAssignment.setAssignedName([]);
          selectedAssignment.setAssignedCourseName([]);
        } else {
          CustomToast(`${errorMsg}`, 'warning');
          setIsLoading(false);
        }
      } catch (ex) {
        console.log(ex);
        setIsLoading(false);
      }
    }
  };

  const assignViaHandler = (event) => {
    setAssignViaId(event.target.value);
  };

  return (
    <Modal
      contentWidth="800px"
      isOpen={modalData}
      titleName={'Duplicate Assignment'}
      onClose={() => setModalData(false)}>
      <div className="duplicate-wrapper">
        <div className="duplicate-content p-4">
          <div className="duplicate-icon pb-3">
            <img src={duplicate} className="img-fluid" />
          </div>
          <div>
            <h5 className="">Are you sure that you want to duplicate the checked assignment(s)?</h5>
            <p className="mb-0">
              Create new assignments with the same questions as the checked assignments. The names
              of the new assignments will have &apos;(Duplicate #)&apos; appended to them. Note
              that Benchmark Assignments cannot be duplicated.
            </p>
          </div>
          <div className="pt-2">
            <h6 className="duplicate-assign-via">How will you assign this duplicate assignment?</h6>
            <div className="d-flex align-items-center gap-3 duplicate-dropdown">
              <label className="form-label col-3">Assign Via</label>
              <DropDown
                value={selectedAssignment.allAssignedVia}
                onChangeHandler={(e) => assignViaHandler(e)}
                selectedValue={assignViaId}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center gap-2 duplicate-btn">
          <button className="btn btn-castleWhite" onClick={() => setModalData(false)}>
            No
          </button>
          <button
            className="btn btn-castleRed"
            disabled={isLoading}
            onClick={duplicateAssignmentAsync}>
            Yes
          </button>
        </div>
      </div>
    </Modal>
  );
};

DuplicateMenuModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func,
  fromMoreActions: PropTypes.bool,
};
export default DuplicateMenuModal;
